import{ useEffect } from 'react';
import _ from 'lodash';

/**
 * Custom hook to define common skip step logic for the initial wizard step
 * @param {Function} registerInitialComponentValidation - Function from useValidation hook to register initial component validation
 * @param {Object} jobVM - ViewModel object to check initial validation
 * @param {Function} customSkipCallback - callback function to check a specific validation
 */
const useSkipStep = (registerInitialComponentValidation, jobVM, customSkipCallback = _.stubTrue) => {
    useEffect(() => {
        const shouldPageSkip = () => {
            const status = _.get(jobVM, 'baseData.periodStatus.value.code');
            return status === 'Quoted' && customSkipCallback(jobVM);
        };
        registerInitialComponentValidation(shouldPageSkip);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [registerInitialComponentValidation]);
};

export default useSkipStep;